export default __webpack_public_path__ + "static/media/icon_ihmiset_valmis.db706c85.svg";